import * as React from "react";
import { Link } from "react-router-dom";
import FormTypeStore from "../../../../stores/FormTypeStore.js";
import { GetAllFormTypes } from "../../../../actions/FormTypeActions";
import { RequestNav } from "../../../../actions/NavActions";
class FormTypeSidebar extends React.Component {
  constructor() {
    super();
    this.state = {
      formTypeList: [],
      searchText: "",
      filteredFormTypeList: [],
      goToFormType: 0,
      maxHeight: window.innerHeight - 280
    };
    this.onReceiveFormTypeChange = this.onReceiveFormTypeChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onClickFTLink = this.onClickFTLink.bind(this);
  }
  componentDidMount() {
    FormTypeStore.addChangeListener(this.onReceiveFormTypeChange);
    GetAllFormTypes();
  }
  componentWillUnmount() {
    FormTypeStore.removeChangeListener(this.onReceiveFormTypeChange);
  }
  onReceiveFormTypeChange() {
    let lastChange = FormTypeStore.getLastAction();
    if (lastChange.actionType === "FTGetAll") {
      let formTypes = FormTypeStore.getAllFormTypes();
      this.setState({
        formTypeList: formTypes,
        searchText: "",
        filteredFormTypeList: formTypes
      });
    }
  }
  onClickFTLink(ft) {
    console.log(ft);
    this.setState({ goToFormType: ft }, () => {
      RequestNav("FormType", "formTypeLink");
    });
  }
  onSearchChange(e) {
    let search = e.target.value;
    if (search === "") {
      let newList = [...this.state.formTypeList];
      this.setState({ searchText: search, filteredFormTypeList: newList });
    } else {
      let newList = [];
      this.state.formTypeList.forEach((formType) => {
        if (formType.name.toLowerCase().includes(search.toLowerCase())) {
          newList.push(formType);
        }
      });
      this.setState({ searchText: search, filteredFormTypeList: newList });
    }
  }
  render() {
    let listOfFormTypes;
    if (this.state.filteredFormTypeList !== void 0) {
      listOfFormTypes = this.state.filteredFormTypeList.map((formType) => /* @__PURE__ */ React.createElement("div", { key: formType.formTypeId, onClick: () => this.onClickFTLink(formType.formTypeId), className: "sidebar-link" }, formType.name, " "));
    } else {
      listOfFormTypes = /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/formtypes",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("div", { className: "fs-4" }, /* @__PURE__ */ React.createElement("span", { style: { color: "#23B0DD" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-file-alt" }), "   "), "Form Types")
      ),
      " ",
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { className: "input-group rounded", style: { marginBottom: "16px" } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "search",
          value: this.state.searchText,
          className: "form-control",
          placeholder: "Search",
          "aria-label": "Search",
          onChange: this.onSearchChange,
          "aria-describedby": "search-addon"
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "input-group-text border-0", id: "search-addon" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" }))),
      /* @__PURE__ */ React.createElement("div", { className: "coolScroll", style: { maxHeight: `${this.state.maxHeight}px`, overflowY: "auto" } }, listOfFormTypes),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(
        Link,
        {
          id: "formTypeLink",
          className: "nav-link",
          to: `/Admin/FormType/${this.state.goToFormType}`,
          style: { display: "none" }
        },
        "FormType"
      )
    );
  }
}
export default FormTypeSidebar;
